module.exports = __webpack_public_path__ + "static/media/london_sport.276ba6e1.png";